import m from "../../geodata/es2015/colombiaLow";
window.am4geodata_colombiaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/colombiaLow.js
// module id = null
// module chunks = 